import type { FC } from 'react';
import { Dashboard } from '@/components/dashboard/index.tsx';

export const DashboardPage: FC = () => <Dashboard />;
